<div class="card flex justify-content-start mb-2">
  <div class="flex flex-column gap-2">
    <div *ngFor="let permission of permissions" class="field-checkbox">
      <p-checkbox [disabled]="disabled ? disabled : true" [(ngModel)]="selectedPermissions" (onChange)="checked($event)" [label]="permission.description" name="group" [value]="permission" />
    </div>
  </div>
</div>
